/**
 * Keeps concurrent fetches of the same resource from applying out of order.
 *
 * Every fetch takes a ticket before it starts. A response may be applied only if no response from a
 * LATER ticket has been applied already: a slower request that started earlier (and so may have read the
 * server before a change, e.g. a /progress fetched before a Qi payment completed) must never overwrite
 * newer data. Responses that arrive in order are all applied.
 */
export interface LatestResponseGate {
  /** Ticket for a fetch that is about to start. */
  begin(): number;
  /** True (and records the ticket) when the response of `ticket` is not older than the data already applied. */
  shouldApply(ticket: number): boolean;
}

export function createLatestResponseGate(): LatestResponseGate {
  let started = 0;
  let applied = 0;
  return {
    begin() {
      started += 1;
      return started;
    },
    shouldApply(ticket: number) {
      if (ticket < applied) return false;
      applied = ticket;
      return true;
    },
  };
}
